import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material'

type StepsSectionProps = {
  title?: string
  steps: string[]
}

export const StepsSection = ({ title, steps }: StepsSectionProps) => {
  return (
    <Box px={1.5} my={1.5}>
      {title && (
        <Typography variant="body1" fontWeight="bolder" mb={1.5}>
          {title}
        </Typography>
      )}
      <Stepper alternativeLabel>
        {steps.map((step, index) => (
          <Step completed key={index}>
            <StepLabel>{step}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
